import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from "react";
import { useSafeContext } from "@aviv-unified-frontend/internal";
import { useGlobalStore } from "../../utils/useGlobalStore/useGlobalStore";
import { APPLICATIONS_CACHED } from "./createApplicationCache";
const RuntimeApplicationContext = createContext(null);
export const RuntimeApplicationProvider = ({ children }) => {
    const { initialApplication } = useGlobalStore();
    const [id, setId] = useState(initialApplication?.id);
    const value = useMemo(() => {
        const version = id && APPLICATIONS_CACHED.getApplication(id)?.version;
        return {
            id,
            setId,
            version,
        };
    }, [id]);
    return (_jsx(RuntimeApplicationContext.Provider, { value: value, children: children }));
};
export const useRuntimeApplication = () => useSafeContext({
    package: "@aviv-unified-frontend/branded-shell",
    module: "runtimeApplication",
}, RuntimeApplicationContext);
